import {
  UPDATE_COURSE,
  UPDATE_ACCOMMODATION,
  UPDATE_ADDITIONAL_SERVICE,
  UPDATE_TOTAL_PRICE,
  UPDATE_INSURANCE,
  OPEN_CLOSE_LEAD_DIALOG,
  SET_DEPOSIT,
} from 'store/types/schoolDetailTypes';

export const UpdateCourse = (dispatch, data) => {
  dispatch({ type: UPDATE_COURSE, payload: data });
};

export const UpdateAccommodation = (dispatch, data) => {
  dispatch({ type: UPDATE_ACCOMMODATION, payload: data });
};

export const UpdateAdditionalService = (dispatch, data) => {
  dispatch({ type: UPDATE_ADDITIONAL_SERVICE, payload: data });
};

export const UpdateInsurance = (dispatch, data) => {
  dispatch({ type: UPDATE_INSURANCE, payload: data });
};

export const UpdateTotalPrice = (dispatch, data) => {
  dispatch({ type: UPDATE_TOTAL_PRICE, payload: data });
};

export const OpenCloseDialogLead = (dispatch, data) => {
  dispatch({ type: OPEN_CLOSE_LEAD_DIALOG, payload: data });
};

export const SetDeposit = (dispatch, data) => {
  dispatch({ type: SET_DEPOSIT, payload: data });
};
